module.exports = __webpack_public_path__ + "media/images/responsive/lp/online/main-visual_sp-b318199280d04db13a9e9e68e16ab00f.png";